import { TProduct } from 'shared/types';
import { http } from '../utils/axios';

class ProductVariationsService {
  private static instance: ProductVariationsService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): ProductVariationsService {
    if (!ProductVariationsService.instance) {
      ProductVariationsService.instance = new ProductVariationsService();
    }

    return ProductVariationsService.instance;
  }

  public getProductVariations = async ({
    limit = 99,
    page = 1,
    withoutProducts = '',
    q = ''
  }) => {
    const data = await http<{
      productVariations: TProduct[];
      result: string[];
      count: number;
    }>({
      url: '/productVariations',
      method: 'GET',
      params: {
        limit,
        q,
        withoutProducts,
        page
      }
    });

    return data;
  };
}

const instance = ProductVariationsService.getInstance();

export default instance;
